// Utility helpers for resolving static image URLs in a way that works
// in both dev and production builds (including when the app is served
// from a sub-path or behind a CDN).
//
// Strategy:
// 1) Prefer bundling images that live in src/assets/images so Webpack
//    fingerprints and serves them from the correct public path.
// 2) Fall back to the public /images folder (useful when files are only
//    dropped into /public/images).

// Build a lookup of all images under src/assets/images (recursive).
const imageContext = require.context(
  '@/assets/images',
  true,
  /\.(png|jpe?g|gif|svg|webp|avif)$/i,
);

const imageMap = imageContext.keys().reduce((acc, key) => {
  // keys look like './discography/the_circadian_rhythm.jpg'
  const normalized = key.replace(/^.\//, ''); // remove leading './'
  acc[normalized.toLowerCase()] = imageContext(key);
  return acc;
}, {});

const basePath = (process.env.BASE_URL || '/').replace(/\/$/, '');

export function resolveImageUrl(value) {
  if (!value) return '';

  // Absolute URLs pass straight through.
  if (/^https?:\/\//i.test(value)) return value;

  // Remove leading slashes and any accidental 'images/' prefix so we can match.
  const cleaned = value.replace(/^\/+/, '').replace(/^images\//i, '');
  const lower = cleaned.toLowerCase();

  // Try to find a bundled asset first.
  const matchedKey = Object.keys(imageMap).find((key) => key.endsWith(lower));
  if (matchedKey) {
    return imageMap[matchedKey];
  }

  // Fallback to the public images directory, respecting the build base URL.
  return `${basePath}/images/${cleaned}`;
}

export default {
  resolveImageUrl,
};
